import { property, propertyOf } from 'underscore';

import { addOutcomes, removeOutcomes } from 'sportsbook-outcomes-duck';
import { addMarkets, removeMarkets } from 'sportsbook-markets-duck';
import fetchData from './api';

export const FEATURED_FETCH_DATA_INIT = 'FEATURED_FETCH_DATA_INIT';
export const FEATURED_FETCH_DATA_SUCCESS = 'FEATURED_FETCH_DATA_SUCCESS';
export const FEATURED_RESET_DATA_SUCCESS = 'FEATURED_RESET_DATA_SUCCESS';

export const featuredFetchDataInit = (namespace) => ({
  type: `${namespace}::${FEATURED_FETCH_DATA_INIT}`,
});

export const featuredFetchDataSuccess = (featured) => ({
  type: `${featured.namespace}::${FEATURED_FETCH_DATA_SUCCESS}`,
  featured,
});

export const featuredFetchData = (namespace, componentId) => (dispatch) => {
  dispatch(featuredFetchDataInit(namespace));
  return fetchData(componentId)
    .then((data) => {
      dispatch(addOutcomes(data.outcomes));
      dispatch(addMarkets(data.markets));
      dispatch(featuredFetchDataSuccess({
        namespace,
        sports: data.sports.map((sport) => ({ ...sport, href: data.href })),
        events: data.events,
        marketLayouts: data.market_layouts,
      }));
    });
};

const resetFeaturedDataSuccess = (namespace) => ({
  type: `${namespace}::FEATURED_RESET_DATA_SUCCESS`,
});

export const resetFeaturedData = (namespace) => (dispatch, getState) => {
  const { events } = getState()[namespace];

  // Once we get the events, the method is the same as in upcoming
  // Same data structure, perhaps we should have an action
  // to remove both MarketsAndOutcomes in 1 call
  const marketIds = events.map(property('market_id'));
  const outcomeIds = marketIds.map(propertyOf(getState().markets)).flatMap(property('o'));

  dispatch(removeOutcomes(outcomeIds));
  dispatch(removeMarkets(marketIds));
  dispatch(resetFeaturedDataSuccess(namespace));
};

const initialState = {
  sports: [],
  events: [],
  marketLayouts: {},
  loaded: false,
};

export default (namespace) => (state = initialState, action = {}) => {
  switch (action.type) {
    case `${namespace}::${FEATURED_FETCH_DATA_SUCCESS}`:
      return {
        ...action.featured,
        loaded: true,
      };
    case `${namespace}::${FEATURED_RESET_DATA_SUCCESS}`:
      return initialState;
    default:
      return state;
  }
};
